export interface DiagnosisCodeAnswerType {
    code: string;
    primary: boolean;
}

export const getDiagnosisCodeLabel = (icdCode: { code: string; description?: string }): string =>
    icdCode.description ? `${icdCode.code} - ${icdCode.description}` : icdCode.code;

// At most one code may be primary, and starring the current primary clears it so
// "no primary code" stays reachable.
export const togglePrimaryDiagnosisCode = <T extends DiagnosisCodeAnswerType>(
    selectedCodes: T[],
    code: string
): T[] => {
    const isAlreadyPrimary = selectedCodes.some(
        (diagnosis) => diagnosis.code === code && diagnosis.primary
    );

    return selectedCodes.map((diagnosis) => ({
        ...diagnosis,
        primary: !isAlreadyPrimary && diagnosis.code === code,
    }));
};

// Drops the display-only description before the codes go over the wire.
export const toDiagnosisCodeAnswers = (
    selectedCodes: DiagnosisCodeAnswerType[]
): DiagnosisCodeAnswerType[] =>
    selectedCodes.map((diagnosis) => ({ code: diagnosis.code, primary: diagnosis.primary }));
